import { Card } from "primereact/card";
import Boton from "../Boton/Boton";
import "./CardEntry.scss"
const CardEntry = ({nombreBoton,tituloCard, onClicButton,imagenUrl,opacity}) => {
    const footer = <span>
         <div style={{display:"flex",justifyContent:"right"}}>
            <Boton nombre={nombreBoton} color="primary" widths="50%" icon="pi pi-angle-right" metodoClick={onClicButton}/>
         </div>
        
    </span>;
    return(
        <div className="p-eva-cardEntry-wrap">
            <img className="p-eva-cardEntry-fondo" 
                // style={{backgroundImage: `url(${imagenUrl})`,backgroundSize:"cover",backgroundRepeat:"no-repeat"}}
                src={imagenUrl} style={{opacity:opacity}}
                ></img>
            <Card title={tituloCard} footer={footer} className="eva-cardEntry" 
                />
        </div>
        
    )
}
 
export default CardEntry;